import * as React from "react";
import { Path, Rect, G, Defs, ClipPath, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const CUIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="CU" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#3D58DB"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#3D58DB"
          stroke="#F7FCFF"
          strokeWidth={2}
          d="M17 4v4H-1V4h18Z"
        />
      </G>
      <Path
        fill="#E31D1C"
        fillRule="evenodd"
        d="M0 0v12l9-6-9-6Z"
        clipRule="evenodd"
      />
      <Mask
        id="c"
        width={9}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12l9-6-9-6Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#c)">
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="m3.344 7.108-1.836.97.894-1.948-1.14-1.04 1.407-.052.675-1.76.515 1.76h1.404L4.327 6.13l.744 1.947-1.727-.969Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
